<script>
  import { searching } from './store.js';
  import {
    performSearch,
    performSearchEvent,
    populateFirstSearchFacets,
  } from './search-module.js';
  import ResultsList from './components/results-list.svelte';
  import FacetsList from './components/facets-list.svelte';
  import { tick } from 'svelte';
  import LoadingEllipses from '../animated-loaders/loading-ellipses.svelte';
  import SearchBox from './components/search-box.svelte';
  import ResultsLoadMore from './components/results-load-more.svelte';

  window.addEventListener('popstate', async function () {
    await populateFirstSearchFacets(true);
    await tick();
    await performSearch(false, false);
  });

  window.addEventListener('DOMContentLoaded', performSearch);
</script>

<form class="area-slots" onsubmit={performSearchEvent}>
  <div class="search-controls">
    <FacetsList />
    <SearchBox />
  </div>
  <div class="dynamic-search-results">
    <section class="search-results">
      <ResultsList />
      <ResultsLoadMore />

      {#if $searching}
        <div class="search-spinner">
          <LoadingEllipses />
        </div>
      {/if}
    </section>
  </div>
</form>
